import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material"

const DeleteDialog = ({ onClose, onConfirm, bookTitle }) => {
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Buch löschen</DialogTitle>

      <DialogContent>
        <Typography>
          Soll das Buch <b>{bookTitle}</b> wirklich gelöscht werden?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Nein
        </Button>

        <Button onClick={onConfirm} variant="contained" color="primary">
          Ja
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteDialog
